// src/modules/app-views/goodsReceipt/components/CardHeaderGoodsReceiptTags.jsx
// *******************************************************************************
// GOODS RECEIPT CARD HEADER TAGS
// *******************************************************************************
// Displays status and operation type tags.
// *******************************************************************************
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tag, Tooltip } from 'antd';
import useZustand from 'hooks/useZustand';
import translateX from 'utils/translateX';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const STATUS_COLORS = {
  draft: 'default',
  confirmed: 'success',
  cancelled: 'error',
};

const OPERATION_TYPE_COLORS = {
  national: 'cyan',
  import: 'orange',
};


// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const CardHeaderGoodsReceiptTags = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const currentPage = useZustand?.('module', 'currentPage', false);

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const data = currentPage?.data;
  const isNew = !data?._id || data?._id === 'add';

  const status = isNew ? 'draft' : data?.status || 'draft';
  const operationType = data?.operationType;

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      {/* Status Tag */}
      <Tooltip title={translateX('status')}>
        <Tag color={STATUS_COLORS[status] || 'default'} style={{ margin: 0 }}>
          {translateX(status)}
        </Tag>
      </Tooltip>

      {/* Operation Type Tag */}
      <Tooltip title={translateX('operation_type')}>
        <Tag color={OPERATION_TYPE_COLORS[operationType] || 'cyan'} style={{ margin: 0 }}>
          {translateX(operationType === 'import' ? 'importation' : 'national')}
        </Tag>
      </Tooltip>

    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderGoodsReceiptTags;
